import { render } from "./MagicUrls.vue?vue&type=template&id=3ec9a287&scoped=true"
import script from "./MagicUrls.vue?vue&type=script&lang=js"
export * from "./MagicUrls.vue?vue&type=script&lang=js"

import "./MagicUrls.vue?vue&type=style&index=0&id=3ec9a287&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec9a287"]])

export default __exports__